module.exports = __webpack_public_path__ + "static/img/LOGO.4cf3e98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/KOF15/LOGO.png
// module id = e2n0
// module chunks = 0